// extracted by mini-css-extract-plugin
export var container = "_5k-0";
export var disabled = "_5k-4";
export var fullWidth = "_5k-3";
export var lined = "_5k-1";
export var selected = "_5k-5";
export var tab = "_5k-2";